import { useState, useEffect, useRef } from 'react'
import { useLanguage } from '@context/LanguageContext'
import { useFocusTrap } from '@hooks/useFocusTrap'
import { useEscapeKey } from '@hooks/useEscapeKey'
import { useAutoFocus } from '@hooks/useAutoFocus'
import { getItem, setItem } from '../../../utils/storage'
import styles from './FirefoxWarning.module.css'
import baseStyles from '@styles/modalBase.module.css'

export default function FirefoxWarning () {
  const [isFirefox, setIsFirefox] = useState(false)
  const [dismissed, setDismissed] = useState(false)
  const { t } = useLanguage()

  const modalRef = useRef(null)
  const messageRef = useRef(null)
  const isVisible = isFirefox && !dismissed

  const handleDismiss = () => {
    setItem('firefox-warning-dismissed', 'true')
    setDismissed(true)
  }

  useFocusTrap(modalRef)
  useEscapeKey(handleDismiss, isVisible)
  useAutoFocus(messageRef, isVisible)

  useEffect(() => {
    const isFirefoxBrowser = navigator.userAgent.includes('Firefox')
    const wasDismissed = getItem('firefox-warning-dismissed') === 'true'

    setIsFirefox(isFirefoxBrowser)
    setDismissed(wasDismissed)
  }, [])

  if (!isVisible) return null

  return (
    <div
      className={baseStyles.overlayTop}
      role='dialog'
      aria-modal='true'
      aria-labelledby='firefox-warning-message'
    >

      <div className={styles.firefoxwarning} ref={modalRef}>
        <img
          src='/assets/logos/firefox-logo.webp'
          alt={t.core.firefox.logoAlt}
          className={styles.firefoxLogo}
          aria-hidden='true'
          loading='lazy'
          decoding='async'
        />

        <div className={styles.message}>
          <h2
            id='firefox-warning-message'
            ref={messageRef}
            tabIndex='-1'
          >
            {t.core.firefox.title}
          </h2>
          <p>
            {t.core.firefox.warningMessage}
          </p>
        </div>

        <button
          onClick={handleDismiss}
          className={styles.dismissBtn}
          aria-label={t.core.firefox.dismiss}
        >
          {t.core.firefox.dismiss}
        </button>

        <div className={baseStyles.topHandle} />
      </div>
    </div>
  )
}
